import { Say } from "../../../../arc/locale/consts.js";

const fieldAliases = Object.freeze({
    pinConfirm:"pin"
});

const fieldErrorAliases = Object.freeze({
    locale:Object.freeze({ invalid_format:"unsupported" })
});

const fieldErrorCodes = Object.freeze({
    alias:Object.freeze(["required", "invalid_length", "missing_letter", "invalid_chars", "recurring", "reserved", "not_unique", "legacy"]),
    pin:Object.freeze(["required", "invalid_length", "invalid_format", "mismatch"]),
    locale:Object.freeze(["required", "unsupported"]),
    birthday:Object.freeze(["invalid_format", "future_date"]),
    email:Object.freeze(["invalid_format"]),
    action:Object.freeze(["unsupported"]),
    message:Object.freeze(["too_long", "invalid_chars"]),
    payloadToken:Object.freeze(["required"]),
    phone:Object.freeze(["invalid_format"]),
    reason:Object.freeze(["required", "unsupported"]),
    zip:Object.freeze(["invalid_format"]),
    name:Object.freeze(["invalid_chars"])
});

const commonErrorCodes = Object.freeze([
    "required",
    "required_true",
    "invalid_type",
    "invalid_format",
    "invalid_chars",
    "invalid_length",
    "too_short",
    "too_long",
    "missing_letter",
    "reserved",
    "unsupported",
    "future_date",
    "mismatch",
    "not_unique"
]);

const hasErrors = validation=>{
    if (!validation) { return false; }
    return !!Object.keys(validation.fieldErrors).length || !!validation.formErrors.length;
};

export const getProfileErrorId = (fieldName, error)=>{
    if (!error) { return ""; }

    const profileField = fieldAliases[fieldName] || fieldName;
    const rawCode = error.code || (typeof error === "string" ? error : "invalid");
    const code = fieldErrorAliases[profileField]?.[rawCode] || rawCode;

    if (fieldErrorCodes[profileField]?.includes(code)) {
        return Say.id("profile", "validation", "field", profileField, code);
    }

    if (commonErrorCodes.includes(code)) {
        return Say.id("profile", "validation", "common", code);
    }

    return "profileValidationCommonInvalid";
};

export const getValidationFieldError = (validation, fieldName)=>{
    return validation.fieldErrors[fieldName] || validation.formErrors.find(error=>{
        return error.fields?.includes(fieldName);
    });
};

export const mergeValidation = (localValidation, serverValidation)=>{
    if (!serverValidation) { return localValidation; }
    return {
        ...localValidation,
        isValid:false,
        fieldErrors:{ ...localValidation.fieldErrors, ...serverValidation.fieldErrors },
        formErrors:[ ...localValidation.formErrors, ...serverValidation.formErrors ]
    };
};

export const validationFromReply = reply=>{
    const details = reply?.error?.detail || reply?.details;
    const fieldErrors = details?.fieldErrors || {};
    const formErrors = Array.isArray(details?.formErrors) ? details.formErrors : [];
    const validation = { fieldErrors, formErrors };
    return hasErrors(validation) ? validation : null;
};

export const touchValidationFields = (validation, fallbackFields=[])=>{
    const fields = new Set(Object.keys(validation?.fieldErrors || {}));
    for (const error of validation?.formErrors || []) {
        for (const field of error.fields || []) { fields.add(field); }
    }
    if (!fields.size) {
        for (const field of fallbackFields) { fields.add(field); }
    }
    return Object.fromEntries([...fields].map(field=>[field, true]));
};

export const handleProfileSubmitReply = (reply, handlers)=>{
    const { fields, setIsSubmitting, setServerValidation, setSubmitState, setTouched, onDone } = handlers;

    if (!reply?.error) {
        onDone?.();
        return true;
    }

    const validation = validationFromReply(reply);
    
    if (validation) {
        setServerValidation(validation);
        setTouched(touchValidationFields(validation, fields));
        setSubmitState("validationError");
    } else {
        setSubmitState("submitError");
    }

    setIsSubmitting(false);

    return false;
};
